import { render, staticRenderFns } from "./ViewRequestSlidebar.vue?vue&type=template&id=2b7d98a8"
import script from "./ViewRequestSlidebar.vue?vue&type=script&lang=js"
export * from "./ViewRequestSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports